import { Trascodifica } from './';

export class RichiestaMutuoSearch {
  numeroPagina: number;
  numeroElementi: number;
  assAbitazione: Boolean;
	tutelaAffitto: Boolean;
	tutellaMutuo: Boolean;
	tutelaLegale: Boolean;
	protezioneVita: Boolean;
  finalita: Array<Trascodifica>;
  idStato: number;
  cognome: String;
  nome: String;
  codiceCollaboratore: string;
  convenzione: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/richiesta-mutuo-search.ts